import React from "react";

export default function Input({
  type,
  name,
  className,
  id,
  ariaDescribedby,
  placeholder,
  onChange,
  value,
  values,
  checked,
  defaultChecked,
  disabled,
  defaultValue,
  maxlength,
  readOnly,
  onFocus,
  onBlur,
}) {
  return (
    <input
      type={type}
      name={name}
      values={values}
      value={value}
      className={className}
      id={id}
      aria-describedby={ariaDescribedby}
      onChange={onChange}
      placeholder={placeholder}
      checked={checked}
      defaultChecked={defaultChecked}
      disabled={disabled}
      defaultValue={defaultValue}
      maxLength={maxlength}
      readOnly={readOnly}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  );
}
